import React, { FC } from 'react'
import { slugs } from '@/constants/slugs'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import {
  GHeadingSM,
  GParagraphLG,
  GParagraphMD,
  GResponsiveText,
  GTitleLG,
} from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import { useGiveawayPrizes } from '@/views/PreSales/PreSalesGiveawayView/hooks/useGiveawayPrizes'

export const TruthAndTreasonDetailsContent: FC = () => {
  const { t } = useTranslate('tickets')
  const prizes = useGiveawayPrizes(slugs.truthAndTreason)
  return (
    <div className="mt-3 grid gap-16">
      <div>
        <GParagraphLG color="giveaway-text-subtle-light" className={'mb-6 pt-3'}>
          {t(
            'giveawayTnTExplainer1',
            'Truth & Treason is the inspiring true story of Helmuth Hübener, a 16-year-old who defied the Nazis with nothing more than his courage and a typewriter. When lies ruled a nation, he chose truth, risking everything to resist tyranny.',
          )}
        </GParagraphLG>
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'giveawayTnTExplainer2',
            'This fall, experience the gripping story of the youngest anti-Nazi resister ever executed for treason. Only in theaters, October 17. Pre-order your tickets now to be part of history—and automatically enter to win a once-in-a-lifetime luxury trip through Germany’s most powerful WWII sites.',
          )}
        </GParagraphLG>
      </div>
      <div>
        <GResponsiveText
          color="giveaway-text-primary-dark"
          className="mb-3"
          MobileTextComponent={GTitleLG}
          DesktopTextComponent={GHeadingSM}
        >
          {t('TnTGrandPrize', "Grand Prize – Helmuth Hübener's Legacy Tour (for two)")}
        </GResponsiveText>
        <ul className={'list-disc pl-4'}>
          {prizes?.grandPrizes &&
            prizes?.grandPrizes.map((prizeItem, index) => (
              <li key={index}>
                <GResponsiveText
                  color="giveaway-text-subtle-light"
                  className={'mb-6 pt-3'}
                  MobileTextComponent={GParagraphMD}
                  DesktopTextComponent={GParagraphLG}
                >
                  {prizeItem.title}
                </GResponsiveText>
              </li>
            ))}
        </ul>
        <Translate i18nKey={'EstimatedValueTnT'} t={t}>
          <GResponsiveText
            color="giveaway-text-subtle-light"
            className={'pb-10 pt-3 !font-bold'}
            MobileTextComponent={GParagraphMD}
            DesktopTextComponent={GParagraphLG}
          >
            Total value: $15,000–$20,000.
          </GResponsiveText>
        </Translate>
      </div>
    </div>
  )
}
